/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as MapRouteImport } from './routes/map'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as CallbacksAuthGoogleRouteImport } from './routes/callbacks/auth/google'

const SignOutLazyRouteImport = createFileRoute('/sign-out')()
const SignInOtpLazyRouteImport = createFileRoute('/sign-in-otp')()
const SignInLazyRouteImport = createFileRoute('/sign-in')()
const MapsLazyRouteImport = createFileRoute('/maps')()
const AboutLazyRouteImport = createFileRoute('/about')()
const IndexLazyRouteImport = createFileRoute('/')()
const AuthedRefundsLazyRouteImport = createFileRoute('/_authed/refunds')()
const AuthedOrganizationLazyRouteImport = createFileRoute(
  '/_authed/organization',
)()
const AuthedHomeLazyRouteImport = createFileRoute('/_authed/home')()
const AuthedDashboardLazyRouteImport = createFileRoute('/_authed/dashboard')()
const AuthedAccountLazyRouteImport = createFileRoute('/_authed/account')()
const AuthedSettingsIndexLazyRouteImport =
  createFileRoute('/_authed/settings/')()
const AuthedDevDevToolsLazyRouteImport = createFileRoute(
  '/_authed/dev/dev-tools',
)()
const AuthedSettingsPaymentsStripeConnectIndexLazyRouteImport = createFileRoute(
  '/_authed/settings/payments/stripe-connect/',
)()
const AuthedSettingsPaymentsStripeConnectReturnLazyRouteImport =
  createFileRoute('/_authed/settings/payments/stripe-connect/return')()
const AuthedSettingsPaymentsStripeConnectRefreshLazyRouteImport =
  createFileRoute('/_authed/settings/payments/stripe-connect/refresh')()

const SignOutLazyRoute = SignOutLazyRouteImport.update({
  id: '/sign-out',
  path: '/sign-out',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/sign-out.lazy').then((d) => d.Route))
const SignInOtpLazyRoute = SignInOtpLazyRouteImport.update({
  id: '/sign-in-otp',
  path: '/sign-in-otp',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/sign-in-otp.lazy').then((d) => d.Route))
const SignInLazyRoute = SignInLazyRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/sign-in.lazy').then((d) => d.Route))
const MapsLazyRoute = MapsLazyRouteImport.update({
  id: '/maps',
  path: '/maps',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/maps.lazy').then((d) => d.Route))
const AboutLazyRoute = AboutLazyRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/about.lazy').then((d) => d.Route))
const MapRoute = MapRouteImport.update({
  id: '/map',
  path: '/map',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/map.lazy').then((d) => d.Route))
const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexLazyRoute = IndexLazyRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/index.lazy').then((d) => d.Route))
const AuthedRefundsLazyRoute = AuthedRefundsLazyRouteImport.update({
  id: '/refunds',
  path: '/refunds',
  getParentRoute: () => AuthedRoute,
} as any).lazy(() =>
  import('./routes/_authed/refunds.lazy').then((d) => d.Route),
)
const AuthedOrganizationLazyRoute = AuthedOrganizationLazyRouteImport.update({
  id: '/organization',
  path: '/organization',
  getParentRoute: () => AuthedRoute,
} as any).lazy(() =>
  import('./routes/_authed/organization.lazy').then((d) => d.Route),
)
const AuthedHomeLazyRoute = AuthedHomeLazyRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => AuthedRoute,
} as any).lazy(() => import('./routes/_authed/home.lazy').then((d) => d.Route))
const AuthedDashboardLazyRoute = AuthedDashboardLazyRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthedRoute,
} as any).lazy(() =>
  import('./routes/_authed/dashboard.lazy').then((d) => d.Route),
)
const AuthedAccountLazyRoute = AuthedAccountLazyRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => AuthedRoute,
} as any).lazy(() =>
  import('./routes/_authed/account.lazy').then((d) => d.Route),
)
const AuthedSettingsIndexLazyRoute = AuthedSettingsIndexLazyRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => AuthedRoute,
} as any).lazy(() =>
  import('./routes/_authed/settings/index.lazy').then((d) => d.Route),
)
const AuthedDevDevToolsLazyRoute = AuthedDevDevToolsLazyRouteImport.update({
  id: '/dev/dev-tools',
  path: '/dev/dev-tools',
  getParentRoute: () => AuthedRoute,
} as any).lazy(() =>
  import('./routes/_authed/dev/dev-tools.lazy').then((d) => d.Route),
)
const CallbacksAuthGoogleRoute = CallbacksAuthGoogleRouteImport.update({
  id: '/callbacks/auth/google',
  path: '/callbacks/auth/google',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedSettingsPaymentsStripeConnectIndexLazyRoute =
  AuthedSettingsPaymentsStripeConnectIndexLazyRouteImport.update({
    id: '/settings/payments/stripe-connect/',
    path: '/settings/payments/stripe-connect/',
    getParentRoute: () => AuthedRoute,
  } as any).lazy(() =>
    import('./routes/_authed/settings/payments/stripe-connect/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthedSettingsPaymentsStripeConnectReturnLazyRoute =
  AuthedSettingsPaymentsStripeConnectReturnLazyRouteImport.update({
    id: '/settings/payments/stripe-connect/return',
    path: '/settings/payments/stripe-connect/return',
    getParentRoute: () => AuthedRoute,
  } as any).lazy(() =>
    import('./routes/_authed/settings/payments/stripe-connect/return.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthedSettingsPaymentsStripeConnectRefreshLazyRoute =
  AuthedSettingsPaymentsStripeConnectRefreshLazyRouteImport.update({
    id: '/settings/payments/stripe-connect/refresh',
    path: '/settings/payments/stripe-connect/refresh',
    getParentRoute: () => AuthedRoute,
  } as any).lazy(() =>
    import('./routes/_authed/settings/payments/stripe-connect/refresh.lazy').then(
      (d) => d.Route,
    ),
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexLazyRoute
  '/map': typeof MapRoute
  '/about': typeof AboutLazyRoute
  '/maps': typeof MapsLazyRoute
  '/sign-in': typeof SignInLazyRoute
  '/sign-in-otp': typeof SignInOtpLazyRoute
  '/sign-out': typeof SignOutLazyRoute
  '/account': typeof AuthedAccountLazyRoute
  '/dashboard': typeof AuthedDashboardLazyRoute
  '/home': typeof AuthedHomeLazyRoute
  '/organization': typeof AuthedOrganizationLazyRoute
  '/refunds': typeof AuthedRefundsLazyRoute
  '/callbacks/auth/google': typeof CallbacksAuthGoogleRoute
  '/dev/dev-tools': typeof AuthedDevDevToolsLazyRoute
  '/settings': typeof AuthedSettingsIndexLazyRoute
  '/settings/payments/stripe-connect/refresh': typeof AuthedSettingsPaymentsStripeConnectRefreshLazyRoute
  '/settings/payments/stripe-connect/return': typeof AuthedSettingsPaymentsStripeConnectReturnLazyRoute
  '/settings/payments/stripe-connect': typeof AuthedSettingsPaymentsStripeConnectIndexLazyRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexLazyRoute
  '/map': typeof MapRoute
  '/about': typeof AboutLazyRoute
  '/maps': typeof MapsLazyRoute
  '/sign-in': typeof SignInLazyRoute
  '/sign-in-otp': typeof SignInOtpLazyRoute
  '/sign-out': typeof SignOutLazyRoute
  '/account': typeof AuthedAccountLazyRoute
  '/dashboard': typeof AuthedDashboardLazyRoute
  '/home': typeof AuthedHomeLazyRoute
  '/organization': typeof AuthedOrganizationLazyRoute
  '/refunds': typeof AuthedRefundsLazyRoute
  '/callbacks/auth/google': typeof CallbacksAuthGoogleRoute
  '/dev/dev-tools': typeof AuthedDevDevToolsLazyRoute
  '/settings': typeof AuthedSettingsIndexLazyRoute
  '/settings/payments/stripe-connect/refresh': typeof AuthedSettingsPaymentsStripeConnectRefreshLazyRoute
  '/settings/payments/stripe-connect/return': typeof AuthedSettingsPaymentsStripeConnectReturnLazyRoute
  '/settings/payments/stripe-connect': typeof AuthedSettingsPaymentsStripeConnectIndexLazyRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexLazyRoute
  '/_authed': typeof AuthedRouteWithChildren
  '/map': typeof MapRoute
  '/about': typeof AboutLazyRoute
  '/maps': typeof MapsLazyRoute
  '/sign-in': typeof SignInLazyRoute
  '/sign-in-otp': typeof SignInOtpLazyRoute
  '/sign-out': typeof SignOutLazyRoute
  '/_authed/account': typeof AuthedAccountLazyRoute
  '/_authed/dashboard': typeof AuthedDashboardLazyRoute
  '/_authed/home': typeof AuthedHomeLazyRoute
  '/_authed/organization': typeof AuthedOrganizationLazyRoute
  '/_authed/refunds': typeof AuthedRefundsLazyRoute
  '/callbacks/auth/google': typeof CallbacksAuthGoogleRoute
  '/_authed/dev/dev-tools': typeof AuthedDevDevToolsLazyRoute
  '/_authed/settings/': typeof AuthedSettingsIndexLazyRoute
  '/_authed/settings/payments/stripe-connect/refresh': typeof AuthedSettingsPaymentsStripeConnectRefreshLazyRoute
  '/_authed/settings/payments/stripe-connect/return': typeof AuthedSettingsPaymentsStripeConnectReturnLazyRoute
  '/_authed/settings/payments/stripe-connect/': typeof AuthedSettingsPaymentsStripeConnectIndexLazyRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/map'
    | '/about'
    | '/maps'
    | '/sign-in'
    | '/sign-in-otp'
    | '/sign-out'
    | '/account'
    | '/dashboard'
    | '/home'
    | '/organization'
    | '/refunds'
    | '/callbacks/auth/google'
    | '/dev/dev-tools'
    | '/settings'
    | '/settings/payments/stripe-connect/refresh'
    | '/settings/payments/stripe-connect/return'
    | '/settings/payments/stripe-connect'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/map'
    | '/about'
    | '/maps'
    | '/sign-in'
    | '/sign-in-otp'
    | '/sign-out'
    | '/account'
    | '/dashboard'
    | '/home'
    | '/organization'
    | '/refunds'
    | '/callbacks/auth/google'
    | '/dev/dev-tools'
    | '/settings'
    | '/settings/payments/stripe-connect/refresh'
    | '/settings/payments/stripe-connect/return'
    | '/settings/payments/stripe-connect'
  id:
    | '__root__'
    | '/'
    | '/_authed'
    | '/map'
    | '/about'
    | '/maps'
    | '/sign-in'
    | '/sign-in-otp'
    | '/sign-out'
    | '/_authed/account'
    | '/_authed/dashboard'
    | '/_authed/home'
    | '/_authed/organization'
    | '/_authed/refunds'
    | '/callbacks/auth/google'
    | '/_authed/dev/dev-tools'
    | '/_authed/settings/'
    | '/_authed/settings/payments/stripe-connect/refresh'
    | '/_authed/settings/payments/stripe-connect/return'
    | '/_authed/settings/payments/stripe-connect/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexLazyRoute: typeof IndexLazyRoute
  AuthedRoute: typeof AuthedRouteWithChildren
  MapRoute: typeof MapRoute
  AboutLazyRoute: typeof AboutLazyRoute
  MapsLazyRoute: typeof MapsLazyRoute
  SignInLazyRoute: typeof SignInLazyRoute
  SignInOtpLazyRoute: typeof SignInOtpLazyRoute
  SignOutLazyRoute: typeof SignOutLazyRoute
  CallbacksAuthGoogleRoute: typeof CallbacksAuthGoogleRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/sign-out': {
      id: '/sign-out'
      path: '/sign-out'
      fullPath: '/sign-out'
      preLoaderRoute: typeof SignOutLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in-otp': {
      id: '/sign-in-otp'
      path: '/sign-in-otp'
      fullPath: '/sign-in-otp'
      preLoaderRoute: typeof SignInOtpLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/maps': {
      id: '/maps'
      path: '/maps'
      fullPath: '/maps'
      preLoaderRoute: typeof MapsLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/map': {
      id: '/map'
      path: '/map'
      fullPath: '/map'
      preLoaderRoute: typeof MapRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/refunds': {
      id: '/_authed/refunds'
      path: '/refunds'
      fullPath: '/refunds'
      preLoaderRoute: typeof AuthedRefundsLazyRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/organization': {
      id: '/_authed/organization'
      path: '/organization'
      fullPath: '/organization'
      preLoaderRoute: typeof AuthedOrganizationLazyRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/home': {
      id: '/_authed/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof AuthedHomeLazyRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/dashboard': {
      id: '/_authed/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthedDashboardLazyRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/account': {
      id: '/_authed/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AuthedAccountLazyRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/settings/': {
      id: '/_authed/settings/'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthedSettingsIndexLazyRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/dev/dev-tools': {
      id: '/_authed/dev/dev-tools'
      path: '/dev/dev-tools'
      fullPath: '/dev/dev-tools'
      preLoaderRoute: typeof AuthedDevDevToolsLazyRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/callbacks/auth/google': {
      id: '/callbacks/auth/google'
      path: '/callbacks/auth/google'
      fullPath: '/callbacks/auth/google'
      preLoaderRoute: typeof CallbacksAuthGoogleRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/settings/payments/stripe-connect/': {
      id: '/_authed/settings/payments/stripe-connect/'
      path: '/settings/payments/stripe-connect'
      fullPath: '/settings/payments/stripe-connect'
      preLoaderRoute: typeof AuthedSettingsPaymentsStripeConnectIndexLazyRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/settings/payments/stripe-connect/return': {
      id: '/_authed/settings/payments/stripe-connect/return'
      path: '/settings/payments/stripe-connect/return'
      fullPath: '/settings/payments/stripe-connect/return'
      preLoaderRoute: typeof AuthedSettingsPaymentsStripeConnectReturnLazyRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/settings/payments/stripe-connect/refresh': {
      id: '/_authed/settings/payments/stripe-connect/refresh'
      path: '/settings/payments/stripe-connect/refresh'
      fullPath: '/settings/payments/stripe-connect/refresh'
      preLoaderRoute: typeof AuthedSettingsPaymentsStripeConnectRefreshLazyRouteImport
      parentRoute: typeof AuthedRoute
    }
  }
}

interface AuthedRouteChildren {
  AuthedAccountLazyRoute: typeof AuthedAccountLazyRoute
  AuthedDashboardLazyRoute: typeof AuthedDashboardLazyRoute
  AuthedHomeLazyRoute: typeof AuthedHomeLazyRoute
  AuthedOrganizationLazyRoute: typeof AuthedOrganizationLazyRoute
  AuthedRefundsLazyRoute: typeof AuthedRefundsLazyRoute
  AuthedDevDevToolsLazyRoute: typeof AuthedDevDevToolsLazyRoute
  AuthedSettingsIndexLazyRoute: typeof AuthedSettingsIndexLazyRoute
  AuthedSettingsPaymentsStripeConnectRefreshLazyRoute: typeof AuthedSettingsPaymentsStripeConnectRefreshLazyRoute
  AuthedSettingsPaymentsStripeConnectReturnLazyRoute: typeof AuthedSettingsPaymentsStripeConnectReturnLazyRoute
  AuthedSettingsPaymentsStripeConnectIndexLazyRoute: typeof AuthedSettingsPaymentsStripeConnectIndexLazyRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedAccountLazyRoute: AuthedAccountLazyRoute,
  AuthedDashboardLazyRoute: AuthedDashboardLazyRoute,
  AuthedHomeLazyRoute: AuthedHomeLazyRoute,
  AuthedOrganizationLazyRoute: AuthedOrganizationLazyRoute,
  AuthedRefundsLazyRoute: AuthedRefundsLazyRoute,
  AuthedDevDevToolsLazyRoute: AuthedDevDevToolsLazyRoute,
  AuthedSettingsIndexLazyRoute: AuthedSettingsIndexLazyRoute,
  AuthedSettingsPaymentsStripeConnectRefreshLazyRoute:
    AuthedSettingsPaymentsStripeConnectRefreshLazyRoute,
  AuthedSettingsPaymentsStripeConnectReturnLazyRoute:
    AuthedSettingsPaymentsStripeConnectReturnLazyRoute,
  AuthedSettingsPaymentsStripeConnectIndexLazyRoute:
    AuthedSettingsPaymentsStripeConnectIndexLazyRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexLazyRoute: IndexLazyRoute,
  AuthedRoute: AuthedRouteWithChildren,
  MapRoute: MapRoute,
  AboutLazyRoute: AboutLazyRoute,
  MapsLazyRoute: MapsLazyRoute,
  SignInLazyRoute: SignInLazyRoute,
  SignInOtpLazyRoute: SignInOtpLazyRoute,
  SignOutLazyRoute: SignOutLazyRoute,
  CallbacksAuthGoogleRoute: CallbacksAuthGoogleRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
